import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import isObject from "lodash/isObject";

const SelectRadioInput = ({
  name,

  value,
  onChange,
  options = [],

  row = false,
  size = "small",
}) => (
  <RadioGroup
    row={row}
    name={name}
    value={value ?? ""}
    onChange={(e) => onChange(e.target.value)}
  >
    {options.map((opt) => {
      const val = isObject(opt) ? opt.value : opt;
      const radioValue = typeof val === "boolean" ? String(val) : val;
      const radioLabel =
        (isObject(opt) && (opt.label || String(radioValue))) || opt;
      return (
        <FormControlLabel
          key={radioValue}
          value={radioValue}
          control={<Radio sx={{ ml: 1 }} size={size} />}
          label={radioLabel}
          sx={{
            span: {
              fontSize: "12px",
            },
          }}
        />
      );
    })}
  </RadioGroup>
);

export default SelectRadioInput;
